import PropTypes from 'prop-types'
import { ThemeProvider, useTheme } from '@emotion/react'
import { Button } from 'chaoskit/src/components'
import { extendTheme } from 'chaoskit/src/helpers/Wrapper'
import { theme as globalTheme } from 'chaoskit/src/assets/styles/theme'
import { shade, tint } from 'polished'
import { MDXProvider } from '@mdx-js/react'

import BaseLayout from './BaseLayout'

import Icon from '~components/Icon'
import StaticFooter from '~partials/footer/StaticFooter'
import ChaosMonkeyResources from '~partials/chaos-monkey/Resources'

const chaosMonkeyTheme = extendTheme(globalTheme, {
  color: {
    primary: {
      base: '#006f7a',
      get light() {
        return tint(0.9, this.base)
      },
      get dark() {
        return shade(0.1, this.base)
      },
      filter:
        'invert(14%) sepia(83%) saturate(4588%) hue-rotate(176deg) brightness(100%) contrast(102%)',
    },
  },
  settings: {
    button: {
      gradient: {
        enable: false,
      },
    },
  },
})

const ChaosMonkeyLayout = ({ children, contrast = true }) => {
  const theme = useTheme()

  return (
    <ThemeProvider theme={chaosMonkeyTheme}>
      <BaseLayout headerProps={{ contrast, forceCTAContrast: true }} noFooter>
        <MDXProvider
          components={{
            ChaosMonkeyResources,
          }}
        >
          {children}
        </MDXProvider>

        <StaticFooter />
        <Button
          type="primary"
          size="small"
          css={{
            position: 'fixed',
            bottom: theme.space.base,
            right: theme.space.base,
            boxShadow: theme.boxShadow.base,
            transition: `transform ${theme.timing.base} ${theme.transition.base}`,
            transformOrigin: 'center center',
            zIndex: 3,

            '&:hover, &:focus': {
              transform: 'scale(1.025)',
            },
          }}
          url="/chaos-monkey-guide-pdf/"
        >
          Download PDF
          <Icon css={{ marginLeft: theme.space.small }} icon="arrow-right" />
        </Button>
      </BaseLayout>
    </ThemeProvider>
  )
}

ChaosMonkeyLayout.propTypes = {
  children: PropTypes.node.isRequired,
  contrast: PropTypes.bool,
}

export default ChaosMonkeyLayout
